/** Dispatched when overlays close so the homepage hero background can resume. */
export const HERO_VIDEO_RESUME_EVENT = "hero-background-video-resume";

export const resumeHeroBackgroundVideo = () => {
  window.dispatchEvent(new Event(HERO_VIDEO_RESUME_EVENT));
};
